function CardDefault({ titulo, texto, img }) {
  return (
    <div className="animated animatedFadeInUp fadeInUp text-blue-connect h-96">
      <div className="bg-gray-cards text-center p-10 mb-5 rounded-lg h-full">
        <div className="flex justify-center pb-3">
          <img src={img} alt={titulo} />
        </div>
        <h2 className="text-4xl font-normal font-blue-connect">{titulo}</h2>
        <p className="text-sm p-8">{texto}</p>
      </div>
    </div>
  );
}

export default CardDefault;
